import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const PriceToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${cssTheme.layout.spacing.s400};
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.md};
  background: ${cssTheme.colors.background.neutral.primary};
`
